module.exports = __webpack_public_path__ + "static/media/mail.9c72343c.svg";